import React, { useEffect } from 'react';
import { FirstSlide } from './components/FirstSlide';
import { SecondSlide } from './components/SecondSlide';
import { ThirdSlide } from './components/ThirdSlide';
export function App() {
  useEffect(() => {
    document.title = 'the 4th';
  }, []);
  return <div className="w-full" data-id="element-0">
      <FirstSlide data-id="element-1" />
      <SecondSlide data-id="element-2" />
      <ThirdSlide data-id="element-3" />
    </div>;
}